import React, { Component, createRef, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import {
    BrandingOption,
    HelpButton,
    HelpButtonAction
} from '../../stores/BrowserBarOptions';
import BrowserBarOptionsStore from '../../stores/BrowserBarOptionsStore';
import FuseConfirmationModal from '../ConfirmationModal/FuseConfirmationModal';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import { Card, Field, FuseWysiwyg } from '../Fuse';
import SnackStore from '../../stores/SnackStore';
import FuseButton from '../FuseControls/FuseButton';
import FuseRadioButton from '../FuseControls/FuseRadioButton';
import FuseTextfield from '../FuseControls/FuseTextfield';
import PagePreview from '../PagePreview/PagePreview';
import {
    BrandingOptionField,
    BrandingOptionView,
    HelpButtonActionField,
    HelpButtonActionView,
    HelpButtonField,
    HelpButtonView
} from './BrowserBarFields';
import BrowserBarPreview from './BrowserBarPeview';

class BrowserBarOptionsModal extends Component {
    static propTypes = {
        snack: SnackStore.PropType.isRequired,
        browserBarOptions: BrowserBarOptionsStore.PropType.isRequired,
    };

    previewRef = createRef();

    setFirstDropdownInPreview = (value) => this.previewRef.current
        && this.previewRef.current.wrappedInstance.getAllStores()[0].browser.customBrandingInfoDropdown.setValue(value);

    submit = () => {
        const { browserBarOptions, snack } = this.props;
        browserBarOptions.update()
            .then(() => snack.showSuccess(<span><b>Browser Bar</b> has been saved</span>))
            .catch((e) => e && snack.showError(<span>Failed to save <b>Browser Bar</b> options. {e.message}</span>));
    }

    renderRadioButtons = (values, store, views) => values.map((value) => <FuseRadioButton
        key={value}
        store={store}
        value={value}
        label={views[value]}
    />);

    render() {
        const store = this.props.browserBarOptions;

        return <FuseConsoleModal
            isOpen={store.editModal.isOpen}
            onClose={store.closeEditModal}
            title="Edit Browser Bar"
            headerActions={<FuseButton
                style={{ minWidth: 100 }}
                color="green"
                primary
                disabled={!store.hasChanged() || !store.isValid()}
                loading={store.updateStatus.isLoading}
                onClick={this.submit}
            >Save</FuseButton>}
        >
            <Card title="Branding">
                <BrandingOptionField tooltipProps={{ position: 'bottomRight' }}>
                    {this.renderRadioButtons([
                        BrandingOption.DEFAULT,
                        BrandingOption.CUSTOM,
                    ], store.brandingOptionStore, BrandingOptionView)}
                </BrandingOptionField>
                {store.isCustomBrandingEditable() ? <Fragment>
                    <Field>
                        <FuseTextfield
                            store={store.customBrandingTextStore}
                            label="Custom Branding"
                            required
                            showRequired
                            // TODO: this should be part of FuseTextfield
                            error={store.customBrandingTextStore.isTouched
                                && !store.customBrandingTextStore.isValid}
                            bottomText={store.customBrandingTextStore.isTouched
                                && store.customBrandingTextStore.errorMessage}
                        />
                    </Field>
                    <FuseConsoleCardFooter
                        text={`Custom branding will not be translated to other languages
                              and cannot exceed ${store.customBrandingTextMaxLength} characters.`}
                    />
                </Fragment> : null}
            </Card>
            <Card title="Help Link">
                <HelpButtonField tooltipProps={{ position: 'bottomRight' }}>
                    {this.renderRadioButtons([
                        HelpButton.DISABLED,
                        HelpButton.ICON,
                        ...(store.brandingOptionStore.equals(BrandingOption.CUSTOM)
                            ? [HelpButton.BRANDING] : []),
                    ], store.helpButtonStore, HelpButtonView)}
                </HelpButtonField>
                {store.helpButtonStore.equals(HelpButton.DISABLED) ? null : <Fragment>
                    <HelpButtonActionField tooltipProps={{ position: 'bottomRight' }}>
                        {this.renderRadioButtons([
                            HelpButtonAction.LINK,
                            HelpButtonAction.POPUP,
                        ], store.helpButtonActionStore, HelpButtonActionView)}
                    </HelpButtonActionField>
                    {store.isExternalLinkEditable() ? <Field>
                        <FuseTextfield
                            store={store.externalLinkStore}
                            label="External Link"
                            required
                            showRequired
                            fullWidth
                            error={store.externalLinkStore.isTouched
                                && !store.externalLinkStore.isValid}
                            bottomText={store.externalLinkStore.isTouched
                                && store.externalLinkStore.errorMessage}
                        />
                    </Field> : null}
                    {store.isPopupMessageEditable() ? <Field
                        label="Popup Message"
                        caption="&nbsp;(required)"
                        // TODO: error
                    >
                        <FuseWysiwyg
                            store={store.popupMessageStore}
                            onFocus={() => this.setFirstDropdownInPreview(true)}
                        />
                    </Field> : null}
                </Fragment>}
            </Card>
            <Card title="Preview">
                <PagePreview
                    pageComponent={BrowserBarPreview}
                    previewToggle={store.modalPreviewToggle}
                    headline="Browser Bar"
                    pageProps={{ browserBarOptions: store.getValue(), ref: this.previewRef }}
                />
            </Card>

            <FuseConfirmationModal
                store={store.exitConfirmationModal}
                onConfirm={store.editModal.close}
            />
        </FuseConsoleModal>;
    }
}

export default inject('browserBarOptions', 'snack')(observer(BrowserBarOptionsModal));
